const filterItem = (it, freeTextOnly, tabName) => !freeTextOnly && it.kind !== tabName || it.kind === 'freeText';
/** @ngInject */
export function accountsPropsFilter() {
    return function (items, props) {
        if (angular.isArray(items)) {
            // do not display same kind as tab selected
            items = items.filter(it => filterItem(it, props.freeTextOnly, props.tabName));

            const out = [];
            items.forEach(item => {
                if (item) {
                    let itemMatches = false;
                    const keys = Object.keys(props);
                    for (let i = 0; i < keys.length; i++) {
                        const prop = keys[i];
                        if (prop in item) {
                            const text = props[prop].toLowerCase();
                            if (item[prop] && item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                                itemMatches = true;
                                break;
                            }
                        }
                    }
                    if (itemMatches) {
                        out.push(item);
                    }
                }
            });

            return out;
        }

        return items;
    };
}
